import * as S from './styles';
import React from 'react';

export enum LabelTypes {
    DEFAULT = 1,
    SOFT = 2,
    STRONG = 3,
}

interface LabelProps {
    labelType?: LabelTypes;
    inputId: string;
    error?: boolean;
    label: React.ReactNode;
}

export const Label: React.FC<LabelProps> = ({
    labelType = LabelTypes.DEFAULT,
    inputId,
    error,
    label,
}: LabelProps) => {
    let labelComponent: React.ReactElement = <></>;

    if (labelType === LabelTypes.STRONG) {
        labelComponent = (
            <S.StrongLabel htmlFor={inputId} $error={error}>
                {label}
            </S.StrongLabel>
        );
    } else if (labelType === LabelTypes.SOFT) {
        labelComponent = (
            <S.SoftLabel htmlFor={inputId} $error={error}>
                {label}
            </S.SoftLabel>
        );
    } else if (labelType === LabelTypes.DEFAULT) {
        labelComponent = (
            <S.Label htmlFor={inputId} $error={error}>
                {label}
            </S.Label>
        );
    }

    return labelComponent;
};
